<div class="alert-container" [ngClass]="data.connotation" [style.width]="data.width ? data.width : '320px'">
    <mat-icon class="material-symbols-outlined alert-icon">{{ data.icon }}</mat-icon>
    <div class="alert-content">
        <h4 class="alert-title">{{ data.title }}</h4>
        <p class="alert-description" [innerHTML]="data.description"></p>
    </div>
    <ng-container *ngIf="data.dismissible">
        <app-button
            *ngIf="!data.dismissButtonLabel"
            [showLabel]="false"
            buttonClass="tertiary"
            [showIcon]="true"
            icon="close"
            (clicked)="snackBarRef.dismiss()"
        ></app-button>
        <app-button
            *ngIf="data.dismissButtonLabel"
            [label]="data.dismissButtonLabel"
            buttonClass="tertiary"
            (clicked)="snackBarRef.dismiss()"
        ></app-button>
    </ng-container>
</div>
